module.exports = __webpack_public_path__ + "static/media/MachineLearningRight.2966ec6a.svg";